import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.086 4.2 20.4 9.514m0 0-5.314 5.314M20.4 9.514H7.6a4 4 0 0 0-4 4V19.8"
    />
  </svg>
);
export default SvgArrowCurveRightUp;
